const MuiInputBase = {
  root: {
    fontSize: '1.6rem',
  },
};

export default MuiInputBase;
